import React from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber } from "../../../../helpers/formatting";
import { Icon, LinkText, Typography } from '../../index';
import './phone_link.scss';

export const PhoneLink = ({
    disabled = false,
    icon, // overrides default phone icon size and color
    phone,
    onClick = () => { }
}) => {

    const disabledColor = "$color-secondary-a3";
    const phoneNumber = phone ? formatPhoneNumber(phone) : '';

    const Element = phoneNumber
        ? LinkText
        : 'div';

    const linkProps = phoneNumber
        ? {
            disabled: disabled,
            href: !disabled ? `tel:${phoneNumber}` : '',
            decorator: "mobile",
        }
        : {}

    return (
        <Element
            className="mybswh-phone-link"
            onClick={!disabled ? onClick : ''}
            {...linkProps}
        >
            <div className="mybswh-phone-link__icon">
                <Icon name="phone" size={icon?.size || "medium"} color={disabled ? disabledColor : icon?.color ? icon?.color : "$color-primary-a3"} />
            </div>
            <div className="mybswh-phone-link__label">
                {phoneNumber
                    ? <Typography type="body-01">
                        {phoneNumber}
                    </Typography>
                    : <Typography type="heading-01" color={disabled ? disabledColor : "$color-secondary-a2"} >
                        -
                    </Typography>
                }
            </div>
        </Element>
    )
}

PhoneLink.propTypes = {
    disabled: PropTypes.bool,
    phone: PropTypes.string,
    onClick: PropTypes.func,
};
